import React from "react";
import { motion } from "framer-motion";

import {
  Bold,
  BookDown,
  Flame,
  FoldVertical,
  Lock,
  ToggleRight,
} from "lucide-react";

const icons = [
  { id: 1, icon: <Lock size={26} />, speed: 8, direction: 1 },
  { id: 2, icon: <FoldVertical size={26} />, speed: 9, direction: -1 },
  { id: 3, icon: <ToggleRight size={26} />, speed: 10, direction: 1 },
  { id: 4, icon: <Flame size={26} />, speed: 11, direction: -1 },
  { id: 5, icon: <Bold size={26} />, speed: 12, direction: 1 },
];

export default function HeroCard15() {
  const radius = 160; // distance from center

  return (
    <>
      <div className="hero-wrapper">

        {/* Left */}
        <div className="hero-content">
          <h1>
            DELIVERING <span>TECHNOLOGY</span> SOLUTIONS
          </h1>
          <p>
            Being accessible, innovative and timely are the basic mantras of our success.
            We create modern SaaS solutions with world-class reliability and design.
          </p>

          <button className="cta">Contact Us</button>
        </div>

        {/* Right – Orbit */}
        <div className="orbit-c15-container">
          {icons.map((item, index) => {
            const angle = (index / icons.length) * 360; // spread evenly

            return (
              <motion.div
                key={item.id}
                className="orbit-c15-item"
                style={{
                  transform: `rotate(${angle}deg) translate(${radius}px) rotate(-${angle}deg)`,
                }}
                animate={{
                  rotate: item.direction === 1 ? 360 : 360,
                }}
                transition={{
                  repeat: Infinity,
                  ease: "linear",
                  duration: item.speed,
                }}
              >
                <div className="circle-card">
                  <div className="icon">{item.icon}</div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>

      {/* CSS */}
      <style>{`
.hero-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 80px 6%;
  background: linear-gradient(120deg, #111, #0a0f18);
  color: white;
}

.hero-content {
  width: 45%;
}

.hero-content h1 {
  font-size: 3.2rem;
  font-weight: 800;
  line-height: 1.2;
}

.hero-content h1 span {
  color: #ff9f43;
}

.hero-content p {
  margin-top: 18px;
  opacity: 0.8;
  font-size: 1.05rem;
  line-height: 1.7;
  max-width: 500px;
}

.cta {
  margin-top: 30px;
  padding: 14px 32px;
  font-size: 1.1rem;
  background: #ff9f43;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: 0.3s;
}
.cta:hover { background: #ffa955; }

/* ORBIT CONTAINER */
.orbit-c15-container {right:50px;bottom:200px;
  width: 420px;
  height: 420px; 
  position: relative;
}

/* Position each icon absolutely on orbit-c15 */
.orbit-c15-item {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;background: rgba(255, 169, 85, 0.1);
  left: 50%;
  transform-origin: center;
}

/* Card style */
.circle-card {
  width: 110px;
  height: 110px;
  background: rgba(255,255,255,0.09);
  border-radius: 50%;
  border: 1px solid rgba(255,255,255,0.18);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon {
  color: #ff9f43;
  font-size: 1.9rem;
}
      `}</style>
    </>
  );
}
